import { classnames } from '@bem-react/classnames'
import type { ComponentProps } from 'react'
import { memo } from 'react'

import css from './ModalFooter.css'

type ModalFooterProps = ComponentProps<'span'>

export const ModalFooter = memo<ModalFooterProps>(function ModalFooter({
  className = '',
  ...rest
}) {
  return <span className={classnames(css.modalFooter, className)} {...rest} />
})
